// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3C2-2","header":"ClearentDisclaimer_header__I8zUI","inner":"ClearentDisclaimer_inner__1Cnv1"};